<template>
  <div class="dashboard-container">
    <el-row>
      <el-col :span="5"><div class="head-side"></div></el-col>
      <el-col :span="14">
        <div class="head-center">
          <div class="head-center-left"></div>
          <div class="head-supercenter">
            <h1>{{ homeTitle }}</h1>
            <el-dropdown
              trigger="click"
              @command="handleCommand"
              class="login-btn"
            >
              <span class="el-dropdown-link">
                <img
                  src="//img.alicdn.com/tps/TB1ld1GNFXXXXXLapXXXXXXXXXX-200-200.png"
                  alt=""
                /><i class="el-icon-caret-bottom el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  {{loginName}}
                </el-dropdown-item>
                <el-dropdown-item command="out">
                  退出
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="head-center-right"></div>
        </div>
      </el-col>
      <el-col :span="5"><div class="head-side"></div></el-col>
    </el-row>

    <el-row :gutter="20" class="row-content">
      <el-col :span="5">
        <div class="super-left">
          <div class="super-left-content">
            <div class="grid-content move-up-first">
              <div class="inner">
                <div class="inner-title">
                  <h2><span>异常与报警提醒</span></h2>
                </div>
                <div class="inner-content circle-box box-flex">
                  <div class="circleBox">
                    <el-progress
                      :width="70"
                      :height="70"
                      color="#E6A23C"
                      type="circle"
                      :show-text="false"
                      :stroke-width="5"
                      :percentage="50"
                    ></el-progress>
                    <div
                      class="circleCenter"
                      style="font-size: 17px;color:white;"
                    >
                      {{ alarmTotalData.dayNum }}
                    </div>
                    <div style="font-size: 10px;color:white">今日报警</div>
                  </div>
                  <div class="circleBox">
                    <el-progress
                      :width="70"
                      :height="70"
                      color="#F56C6C"
                      type="circle"
                      :show-text="false"
                      :stroke-width="5"
                      :percentage="50"
                    ></el-progress>
                    <div
                      class="circleCenter"
                      style="font-size: 17px;color:white;"
                    >
                      {{ alarmTotalData.noHandleNum }}
                    </div>
                    <div style="font-size: 10px;color:white">今日未解决</div>
                  </div>
                  <div class="circleBox">
                    <el-progress
                      :width="70"
                      :height="70"
                      color="#67C23A"
                      type="circle"
                      :show-text="false"
                      :stroke-width="5"
                      :percentage="50"
                    ></el-progress>
                    <div
                      class="circleCenter"
                      style="font-size: 17px;color:white;"
                    >
                      {{ alarmTotalData.handleNum }}
                    </div>
                    <div style="font-size: 10px;color:white">今日已解决</div>
                  </div>
                  <div class="circleBox">
                    <el-progress
                      :width="70"
                      :height="70"
                      color="#409EFF"
                      type="circle"
                      :show-text="false"
                      :stroke-width="5"
                      :percentage="50"
                    ></el-progress>
                    <div
                      class="circleCenter"
                      style="font-size: 17px;color:white;"
                    >
                      {{ alarmTotalData.weekNum }}
                    </div>
                    <div style="font-size: 10px;color:white">近一周</div>
                  </div>
                  <div class="circleBox">
                    <el-progress
                      :width="70"
                      :height="70"
                      color="#F56C6C"
                      type="circle"
                      :show-text="false"
                      :stroke-width="5"
                      :percentage="50"
                    ></el-progress>
                    <div
                      class="circleCenter"
                      style="font-size: 17px;color:white;"
                    >
                      {{ alarmTotalData.monthNum }}
                    </div>
                    <div style="font-size: 10px;color:white">近一月</div>
                  </div>
                  <div class="circleBox">
                    <el-progress
                      :width="70"
                      :height="70"
                      color="#6bbf69"
                      type="circle"
                      :show-text="false"
                      :stroke-width="5"
                      :percentage="50"
                    ></el-progress>
                    <div
                      class="circleCenter"
                      style="font-size: 17px;color:white;"
                    >
                      {{ alarmTotalData.yearNum }}
                    </div>
                    <div style="font-size: 10px;color:white">近一年</div>
                  </div>
                </div>
              </div>
              <div class="boxfoot"></div>
            </div>
          </div>
          <div class="super-left-content chart-box">
            <div class="grid-content move-up-second">
              <div class="inner">
                <div class="inner-title">
                  <h2><span>智能看护报告</span></h2>
                </div>
                <div class="pie-inner-content chart-box-manyflow">
                  <!-- <div id="alarmChart"></div> -->
                  <div style="display:flex;justify-content: center;">
                    <el-button
                      :type="isSelectDay ? 'success' : 'info'"
                      size="mini"
                      @click="updatePieChart(0)"
                      >今日</el-button
                    >
                    <el-button
                      :type="isSelectDay ? 'info' : 'success'"
                      size="mini"
                      @click="updatePieChart(1)"
                      >本月</el-button
                    >
                  </div>
                  <div class="pie-box">
                    <div id="pieChart"></div>
                  </div>
                </div>
              </div>
              <div class="boxfoot"></div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="14">
        <div class="supercenter">
          <div class="supercenter-content">
            <div class="grid-content ">
              <div class="inner">
                <el-tabs
                  v-model="activeName"
                  type="card"
                  class="bigTabs"
                  id="mynewcard"
                >
                  <el-tab-pane label="区域地图" name="first">
                    <div
                      id="container"
                      style="width:100%; height:100%;position: relative;"
                    ></div>
                  </el-tab-pane>

                  <el-tab-pane label="人员列表" name="second">
                    <div class="people-list">
                      <div class="search-box">
                        <el-input
                          placeholder="请输入老人姓名或身份证号"
                          prefix-icon="el-icon-search"
                          v-model="searchName"
                          @change="inputChangeClick"
                        >
                        </el-input>
                      </div>
                      <div
                        class="person-item"
                        v-for="item in memberList"
                        :key="item.memberId"
                        @click="goToDetail(item)"
                      >
                        <div class="person-top">
                          <div class="person-photo">
                            <img
                              v-if="item.headPic == '' || item.headPic == null "
                              src="../assets/images/defaultPhoto.png"
                              alt=""
                            />
                            <img v-else :src="item.headPic" alt="" />
                          </div>
                          <div class="other-info">
                            <div class="other-info-top">
                              <div class="primary-info rightspace">
                                {{ item.age }}岁
                              </div>
                              <div class="primary-info">{{ item.name }}</div>
                            </div>
                            <div class="primary-info address-info">
                              {{ item.address }}
                            </div>
                            <!-- <div class="primary-info address-info">备注: {{item.remark}}</div> -->
                          </div>
                          <div v-if="item.isCallHelper" class="call-help-box">
                            <el-tooltip content="一键呼救" placement="top">
                              <div
                                class="item"
                                @click="callHelpClick(item)"
                                @click.stop=""
                              >
                                <i
                                  class="el-icon-phone"
                                  style="color:white;font-size:24px;"
                                ></i>
                              </div>
                            </el-tooltip>
                          </div>
                          <div
                            class="attend"
                            :class="item.alarmNum <= 0 ? '' : 'unnormal'"
                          >
                            <div class="attend-txt">看护状态</div>
                            <div class="attend-state">
                              {{ item.alarmNum > 0 ? "有通知" : "正常" }}
                            </div>
                          </div>
                        </div>
                        <div class="person-down">
                          <div class="icons-list">
                            <el-tooltip
                              :content="item2.deviceTitle"
                              placement="top"
                              v-for="(item2, index) in item.allDevice"
                              :key="index"
                            >
                              <el-button
                                :class="item2.deviceOn ? 'inline' : 'outline'"
                              >
                                <i
                                  class="iconfont icon-qiujiuhujiaoqi"
                                  v-if="item2.deviceTitle == '一键呼救'"
                                ></i>
                                <i
                                  class="iconfont icon-yangan"
                                  v-else-if="item2.deviceTitle == '烟感'"
                                ></i>
                                <i
                                  class="iconfont icon-shuijin"
                                  v-else-if="item2.deviceTitle == '水浸'"
                                ></i>
                                <i
                                  class="iconfont icon-huabanfuben"
                                  v-else-if="item2.deviceTitle == '门磁'"
                                ></i>
                                <i
                                  class="iconfont icon-hongwai"
                                  v-else-if="item2.deviceTitle == '红外'"
                                ></i>
                                <i
                                  class="iconfont icon-chuangdian"
                                  v-else-if="item2.deviceTitle == '床垫'"
                                ></i>
                                <i
                                  class="iconfont icon-ranqi"
                                  v-else-if="item2.deviceTitle == '燃气'"
                                ></i>
                                <i
                                  class="iconfont icon-wengan"
                                  v-else-if="item2.deviceTitle == '语音呼救'"
                                ></i>
                                <i
                                  class="iconfont icon-shuijin"
                                  v-else-if="item2.deviceTitle == '智能水表'"
                                ></i>
                                <i
                                  class="iconfont icon-genghuanniaodai"
                                  v-else-if="item2.deviceTitle == '尿床带'"
                                ></i>
                                <i
                                  class="iconfont icon-genghuanniaodai"
                                  v-else-if="item2.deviceTitle == '跌倒监测设备'"
                                ></i>
                                <i
                                  class="iconfont icon-qiujiuhujiaoqi"
                                  v-else-if="item2.deviceTitle == '穿戴定位器'"
                                ></i>
                                <i
                                  class="iconfont icon-wengan"
                                  v-else-if="item2.deviceTitle == '语音报警按钮'"
                                ></i>
                              </el-button>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;justify-content: center;">
                      <div style="margin-top: 10px;">
                        <el-pagination
                          @current-change="pageChange"
                          background
                          layout="prev, pager, next"
                          :total="memberAllList.length">
                        </el-pagination>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div class="boxfoot"></div>
            </div>
          </div>
          <div class="supercenter-content twoblock">
            <div class="half-item left-half">
              <div class="grid-content">
                <div class="inner">
                  <div class="inner-title">
                    <h2>设备工况</h2>
                  </div>
                  <div class="inner-content service-content">
                    <div class="service-txt">
                      <div class="service-item">
                        <div class="service-title">网络终端设备</div>
                        <div class="service-data">
                          <span class="on">在线 {{ deviceNum.deviceNum }}</span>
                          <span class="out">离线 0</span>
                        </div>
                      </div>
                      <div class="service-item">
                        <div class="service-title">智能主机</div>
                        <div class="service-data">
                          <span class="on">在线 {{ deviceNum.hostNum }}</span>
                          <span class="out">离线 0</span>
                        </div>
                      </div>
                      <div class="service-days">
                        <div class="day">
                          <div
                            id="days01"
                            style="width:100%; height:100%;"
                          ></div>
                        </div>
                        <div class="day">
                          <div
                            id="days02"
                            style="width:100%; height:100%;"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="service-img">
                      <div class="device-service-img"></div>
                      <!-- <img src="../assets/images/device.png" alt=""> -->
                    </div>
                  </div>
                </div>
                <div class="boxfoot"></div>
              </div>
            </div>
            <div class="half-item right-half">
              <div class="grid-content">
                <div class="inner">
                  <div class="inner-title">
                    <h2>设备统计</h2>
                  </div>
                  <div class="inner-content">
                    <div class="other-img">
                      <!-- <div class="other-img-box"></div> -->
                      <!-- <img src="../assets/images/other.png" alt=""> -->
                      <div id="deviceChart"></div>
                    </div>
                  </div>
                </div>
                <div class="boxfoot"></div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="grid-content moveup">
          <div class="inner">
            <div class="inner-title">
              <h2>报警通知</h2>
            </div>
            <div class="inner-content manyflow">
              <div class="noticeList">
                <div
                  @click="searchConnactClick(item)"
                  class="notice-item"
                  v-for="(item, index) in noticeData"
                  :key="index"
                  :class="index % 2 == 0 ? 'havebg' : ''"
                >
                  <div class="notice-content-top">
                    <div style="font-size: 16px;font-weight: bold;">{{ item.name }}</div>
                    <div style="font-size:13px;">{{ item.alarmTime }}</div>
                  </div>
                  <div style="font-size:14px;padding-top:10px;">
                    <div style="margin-bottom: 5px;">
                      {{ item.remark}}
                    </div>
<!--                    <div v-if="item.handleResult && item.handleResult.length > 0" class="handle-result">-->
<!--                      <span style="color: white;">处理记录：</span>-->
<!--                      {{item.handleResult}}-->
<!--                    </div>-->
                  </div>
                  <div class="address" style="font-size:13px;padding-top:10px;">
                    地址:{{item.attr == '301' ? item.talkUrl : item.address }}
                  </div>
                  <div
                    class="telphone"
                    style="font-size:13px;padding-top:10px;"
                  >
                    联系方式:{{ item.phoneNo }}
                  </div>
                  <div class="result">
                    <div v-if="item.status == 1">
                      <el-tag v-if="item.isEffective == 1" type="success" size="small">有效</el-tag>
                      <el-tag v-else type="danger" size="small">无效</el-tag>
                    </div>
                    <div v-else></div>
                    <div>
                    <span v-if="item.status == 1">已解决</span>
                      <span style="color:orange;" v-else>未解决</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="boxfoot" @click="searchMoreClick">
            查看更多
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 老人详细信息对话框 -->
    <el-dialog
      :visible.sync="dialogOldmanInfo"
      width="80%"
      @close="memberDialogClose"
      @opened="memberOpened"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-left">
            <div class="person-top">
              <div class="person-photo">
                <img
                  v-if="selectedMemberData.headPic == null"
                  src="../assets/images/defaultPhoto.png"
                  alt=""
                />
                <img v-else :src="selectedMemberData.headPic" alt="" />
              </div>

              <div class="other-info">
                <div class="primary-info" style="font-size:18px;">
                  {{ selectedMemberData.name }}
                </div>
                <div class="other-info-top">
                  <div class="primary-info rightspace">
                    {{ selectedMemberData.age }}岁
                  </div>
                  <div class="primary-info sex-info">
                    {{ selectedMemberData.genderView }}
                  </div>
                </div>
                <!-- <div class="primary-info address-info">地址: {{selectedAddress}}</div>
                <div class="primary-info address-info">备注: {{selectedMemberData.remark}}</div> -->
              </div>
              <div
                class="attend"
                :class="selectedMemberData.alarmNum <= 0 ? '' : 'unnormal'"
              >
                <div class="attend-txt">看护状态</div>
                <div class="attend-state">
                  {{ selectedMemberData.alarmNum > 0 ? "有通知" : "正常" }}
                </div>
              </div>
            </div>
            <div class="person-down">
              <div class="icons-list">
                <el-tooltip
                  :content="item2.deviceTitle"
                  placement="top"
                  v-for="(item2, index) in selectedMemberData.allDevice"
                  :key="index"
                >
                  <el-button :class="item2.deviceOn ? 'inline' : 'outline'">
                    <i
                      class="iconfont icon-qiujiuhujiaoqi"
                      v-if="item2.deviceTitle == '一键呼救'"
                    ></i>
                    <i
                      class="iconfont icon-yangan"
                      v-else-if="item2.deviceTitle == '烟感'"
                    ></i>
                    <i
                      class="iconfont icon-shuijin"
                      v-else-if="item2.deviceTitle == '水浸'"
                    ></i>
                    <i
                      class="iconfont icon-huabanfuben"
                      v-else-if="item2.deviceTitle == '门磁'"
                    ></i>
                    <i
                      class="iconfont icon-hongwai"
                      v-else-if="item2.deviceTitle == '红外'"
                    ></i>
                    <i
                      class="iconfont icon-chuangdian"
                      v-else-if="item2.deviceTitle == '床垫'"
                    ></i>
                    <i
                      class="iconfont icon-ranqi"
                      v-else-if="item2.deviceTitle == '燃气'"
                    ></i>
                    <i
                      class="iconfont icon-wengan"
                      v-else-if="item2.deviceTitle == '语音呼救'"
                    ></i>
                    <i
                      class="iconfont icon-shuijin"
                      v-else-if="item2.deviceTitle == '智能水表'"
                    ></i>
                    <i
                      class="iconfont icon-genghuanniaodai"
                      v-else-if="item2.deviceTitle == '尿床带'"
                    ></i>
                    <i
                      class="iconfont icon-genghuanniaodai"
                      v-else-if="item2.deviceTitle == '跌倒监测设备'"
                    ></i>
                    <i
                      class="iconfont icon-qiujiuhujiaoqi"
                      v-else-if="item2.deviceTitle == '穿戴定位器'"
                    ></i>
                    <i
                      class="iconfont icon-wengan"
                      v-else-if="item2.deviceTitle == '语音报警按钮'"
                    ></i>
                  </el-button>
                </el-tooltip>
              </div>
            </div>
            <div style="color:#fff;text-align:left;">详细信息</div>
            <div class="member-detail-info">
              <div class="detail-info-item">
                <label class="detail-label-title">联系方式:</label>
                <label>{{ selectedMemberData.phoneNo }}</label>
              </div>
              <div class="detail-info-item">
                <label class="detail-label-title">居住区域:</label>
                <label>{{ selectedMemberData.areaName }}</label>
              </div>
              <div class="detail-info-item">
                <label class="detail-label-title">居住地址:</label>
                <label>{{ selectedMemberData.address }}</label>
              </div>
              <!-- <div class="detail-info-item">
                <label class="detail-label-title">户籍区域:</label>
                <label>{{olderDetailInfo.registrationAddress}}</label>
              </div>
              <div class="detail-info-item">
                <label class="detail-label-title">户籍地址:</label>
                <label>{{olderDetailInfo.registrationAddress}}</label>
              </div> -->
              <div class="detail-info-item">
                <label class="detail-label-title">身份标签:</label>
                <el-tag
                  type="warning"
                  size="small"
                  v-for="(item, index) in getOlderMemberTag(
                    selectedMemberData.memberTag
                  )"
                  :key="index"
                  >{{ getMemberTagType(item) }}</el-tag
                >
              </div>
              <div class="detail-info-item">
                <label class="detail-label-title">失能情况:</label>
                <label>{{
                  getOlderDisablity(olderDetailInfo.disability)
                }}</label>
              </div>
              <div class="detail-info-item">
                <label class="detail-label-title">居住情况:</label>
                <label>{{
                  getOlderLiveStatus(olderDetailInfo.liveStatus)
                }}</label>
              </div>
              <div class="detail-info-item">
                <div class="detail-label-title" style="margin-bottom:5px;">
                  紧急联系人:
                </div>
                <div
                  class="person-contact"
                  v-for="(item, index) in selectedMemberData.contacts"
                  :key="index"
                >
                  <div class="contact-item">联系人:{{ item.name }}</div>
                  <div class="contact-item">关系:{{ item.relation }}</div>
                  <div class="contact-item">电话:{{ item.telphone }}</div>
                </div>
              </div>
            </div>
            <div style="color:#fff;">今日预警数据</div>
            <div id="memberAlterChart"></div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-right">
            <!-- 生活习惯监测 开始 -->
            <div class="cell right-first-cell">
              <div class="cell-head">生活习惯监测</div>
              <div class="cell-body small-cell">
                <el-tabs
                  v-model="activeNameHealth"
                  @tab-click="tabHandleClick"
                  class="smallTabs"
                >
                  <el-tab-pane
                    :label="miniItem"
                    :name="'liveHabit' + miniIndex"
                    v-for="(miniItem, miniIndex) in lifeHabitTabs"
                    :key="miniIndex"
                  >
                    <div class="mini-cell">
                      <div class="mini-left">
                        <div class="mini-head">
                          <span class="stand">监测指标</span>
                          <span class="lie"></span>
                        </div>
                        <div class="mini-left-list">
                          <div
                            class="mini-left-item"
                            :class="{
                              activeMon: selectMonIndex == miniIndex02
                            }"
                            v-for="(minItem02, miniIndex02) in monitoringDatas"
                            :key="miniIndex02"
                            @click="subLifeClic(minItem02, miniIndex02)"
                          >
                            <div class="mini-left-text">
                              {{ minItem02.controlTitle }}
                            </div>
                            <!-- <div class="mini-left-number">{{minItem02.recordNumber}}</div> -->
                          </div>
                        </div>
                      </div>
                      <div class="mini-right">
                        <div class="mini-head">
                          <span class="stand">{{ selectMonitorTitle }}</span>
                          <span class="lie"></span>
                        </div>
                        <div
                          v-if="selectMonitorTitle === '智能水表'"
                          class="mini-right-table"
                        >
                          <el-table
                            :data="habitWaterDetailData"
                            height="100%"
                            stripe
                            class="mini-table"
                            style="width: 100%"
                          >
                            <!-- 时间  总用水量  昨日用水量  今日用水量 -->
                            <el-table-column
                              prop="dataTime"
                              label="时间"
                              width="140"
                            >
                            </el-table-column>
                            <el-table-column prop="weight" label="总用水量">
                              <template slot-scope="scope">
                                <span style="margin-left: 10px"
                                  >{{ scope.row.weight }}L</span
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="headPosition"
                              label="昨日用水量"
                            >
                              <template slot-scope="scope">
                                <span style="margin-left: 10px"
                                  >{{ scope.row.headPosition }}L</span
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="chestPosition"
                              label="今日用水量"
                            >
                              <template slot-scope="scope">
                                <span style="margin-left: 10px"
                                  >{{ scope.row.chestPosition }}L</span
                                >
                              </template>
                            </el-table-column>
                          </el-table>
                        </div>
                        <div v-else class="mini-right-table">
                          <el-table
                            :data="habitDetailData"
                            height="100%"
                            stripe
                            class="mini-table"
                            style="width: 100%"
                          >
                            <el-table-column
                              prop="state"
                              label="监测名称"
                              :formatter="stateFormat"
                            >
                            </el-table-column>
                            <el-table-column prop="dataTime" label="时间">
                            </el-table-column>
                          </el-table>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
            <!-- 生活习惯监测 结束 -->
            <!-- 健康数据 开始 -->
            <div class="cell">
              <div class="cell-head">健康数据</div>
              <div class="cell-body small-cell">
                <el-tabs
                  v-model="selectHealthTabTitle"
                  @tab-click="tabHandleHealthClick"
                  class="smallTabs"
                >
                  <el-tab-pane
                    :label="miniItem2"
                    :name="miniItem2"
                    v-for="(miniItem2, miniIndex2) in healthTabsTitle"
                    :key="miniIndex2"
                  >
                    <div class="mini-cell">
                      <div class="mini-left">
                        <div class="mini-head">
                          <span class="stand">监测指标</span>
                          <span class="lie"></span>
                        </div>
                        <div class="mini-left-list">
                          <div
                            class="mini-left-item"
                            v-for="(minItem02,
                            miniIndex02) in healthMonitorData"
                            :key="miniIndex02"
                          >
                            <div class="mini-left-text">
                              <i
                                class="iconfont icon-xintiaozhenduanmaidongboxianqushishujuxianxing"
                                v-if="minItem02.controlTitle == '心跳'"
                              ></i>
                              <i
                                class="iconfont icon-huxi"
                                v-else-if="minItem02.controlTitle == '呼吸'"
                              ></i>
                              <i
                                class="iconfont icon-matong"
                                v-else-if="minItem02.controlTitle == '头位'"
                              ></i>
                              <i
                                class="iconfont icon-maibo"
                                v-else-if="minItem02.controlTitle == '脉搏'"
                              ></i>
                              <i
                                class="iconfont icon-niaosuan"
                                v-else-if="minItem02.controlTitle == '尿湿'"
                              ></i>
                              <i
                                class="iconfont icon-zongdanguchun"
                                v-else-if="minItem02.controlTitle == '胸位'"
                              ></i>
                              {{ minItem02.controlTitle }}
                            </div>
                            <div class="mini-left-number">
                              {{ minItem02.recordNumber }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mini-right">
                        <div class="mini-head">
                          <span class="stand">{{ miniItem2 }}</span>
                          <span class="lie"></span>
                        </div>
                        <div class="mini-right-table">
                          <el-table
                            :data="healthDataLists"
                            stripe
                            height="100%"
                            class="mini-table"
                            style="width: 100%"
                          >
                            <el-table-column
                              :prop="getHealthType(selectHealthTabTitle)"
                              :formatter="stateHealthFormat"
                              label="监测名称"
                            >
                            </el-table-column>
                            <el-table-column
                              :prop="getHealthType(selectHealthTabTitle)"
                              label="数据"
                            >
                              <template slot-scope="scope">
                                <span v-if="miniItem2 === '在床状态'">{{
                                  onBeedStatus(scope.row.weight)
                                }}</span>
                                <span v-else-if="miniItem2 === '心跳'">{{
                                  scope.row.heartbeat
                                }}</span>
                                <span v-else-if="miniItem2 === '呼吸'">{{
                                  scope.row.pneusis
                                }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="dataTime"
                              width="142"
                              label="时间"
                            >
                            </el-table-column>
                          </el-table>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
            <!-- 健康数据 结束 -->
            <!-- 报警通知 开始 -->
            <div class="cell">
              <div class="cell-head">报警通知</div>
              <div class="cell-body alert-box">
                <el-table
                  :data="memberAlertNotices"
                  height="100%"
                  stripe
                  style="width: 100%"
                >
                  <el-table-column show-tooltip-when-overflow prop="imei" width="120" label="设备ID">
                  </el-table-column>
                  <el-table-column width="100" label="设备类型">
                    <template slot-scope="scope">
                      {{ getDeviceName(scope.row.deviceType) }}
                    </template>
                  </el-table-column>
                  <el-table-column show-tooltip-when-overflow label="通知类别">
                    <template slot-scope="scope">
                      {{ scope.row.remark }}
                    </template>
                  </el-table-column>
                  <el-table-column width="80" label="报警人">
                    <template slot-scope="scope">
                      {{ scope.row.realName }}
                    </template>
                  </el-table-column>
                  <el-table-column width="170" prop="alarmTime" label="通知时间">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 报警通知 结束 -->
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 地图弹出对话框 -->
    <el-dialog :visible.sync="mapMarkerDailog" width="25%">
      <div class="map-mark-dialog">
        <div class="person-top">
          <div class="person-photo">
            <img
              v-if="clickMember.headPic == null"
              src="../assets/images/defaultPhoto.png"
              alt=""
            />
            <img v-else :src="clickMember.headPic" alt="" />
          </div>

          <div class="other-info">
            <div class="other-info-top">
              <div class="primary-info rightspace">{{ clickMember.age }}岁</div>
              <div class="primary-info">{{ clickMember.name }}</div>
            </div>
            <div class="primary-info address-info">
              {{ clickMember.address }}
            </div>
          </div>

          <div
            class="attend"
            :class="clickMember.alarmNum <= 0 ? '' : 'unnormal'"
          >
            <div class="attend-txt">看护状态</div>
            <div class="attend-state">
              {{ clickMember.alarmNum > 0 ? "有通知" : "正常" }}
            </div>
          </div>
        </div>
        <div class="person-down">
          <div class="icons-list">
            <el-tooltip
              :content="item2.deviceTitle"
              placement="top"
              v-for="(item2, index) in clickMember.allDevice"
              :key="index"
            >
              <el-button :class="item2.deviceOn ? 'inline' : 'outline'">
                <i
                  class="iconfont icon-qiujiuhujiaoqi"
                  v-if="item2.deviceTitle == '一键呼救'"
                ></i>
                <i
                  class="iconfont icon-yangan"
                  v-else-if="item2.deviceTitle == '烟感'"
                ></i>
                <i
                  class="iconfont icon-shuijin"
                  v-else-if="item2.deviceTitle == '水浸'"
                ></i>
                <i
                  class="iconfont icon-huabanfuben"
                  v-else-if="item2.deviceTitle == '门磁'"
                ></i>
                <i
                  class="iconfont icon-hongwai"
                  v-else-if="item2.deviceTitle == '红外'"
                ></i>
                <i
                  class="iconfont icon-chuangdian"
                  v-else-if="item2.deviceTitle == '床垫'"
                ></i>
                <i
                  class="iconfont icon-ranqi"
                  v-else-if="item2.deviceTitle == '燃气'"
                ></i>
                <i
                  class="iconfont icon-wengan"
                  v-else-if="item2.deviceTitle == '语音呼救'"
                ></i>
                <i
                  class="iconfont icon-shuijin"
                  v-else-if="item2.deviceTitle == '智能水表'"
                ></i>
                <i
                  class="iconfont icon-genghuanniaodai"
                  v-else-if="item2.deviceTitle == '尿床带'"
                ></i>
              </el-button>
            </el-tooltip>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 报警弹框 -->
    <el-dialog
      :visible.sync="alarmDialogVisible"
      @close="alarmDialogCloseClick"
      width="700px"
      :center="true"
    >
      <div class="map-mark-dialog">
        <div class="person-top">
          <div class="person-photo">
            <img
              v-if="alarmData.headPic == null"
              src="../assets/images/defaultPhoto.png"
              alt=""
            />
            <img v-else :src="alarmData.headPic" alt="" />
          </div>
          <div id="memberId" style="display:none;">
            {{ alarmData.memberId }}
          </div>
          <div class="other-info">
            <div class="other-info-top">
              <div class="primary-info rightspace">{{ alarmData.age }}岁</div>
              <div class="primary-info">{{ alarmData.realName }}</div>
            </div>
            <div class="primary-info address-info">{{ alarmData.addrNo }}</div>
          </div>

          <div class="attend unnormal">
            <div class="attend-txt">看护状态</div>
            <div class="attend-state">有通知</div>
          </div>
        </div>
        <div class="person-center">
          {{ alarmData.realName }}在{{
            alarmData.address == null ? alarmData.addrNo : alarmData.address
          }}{{ alarmData.remark }}，请迅速检查
        </div>
        <!-- <div>
          <el-button v-if="alarmData.deviceType == 131" style="margin-left:20px" icon="el-icon-phone" type="success" circle size="small" @click="pushTalkSosClick"></el-button>
        </div> -->
        <div class="person-end">
          <el-table
            :data="alarmData.contacts"
            style="width: 100%;margin-bottom:10px;"
          >
            <el-table-column prop="name" label="姓名" width="100">
            </el-table-column>
            <el-table-column prop="relation" label="关系" width="100">
            </el-table-column>
            <el-table-column prop="telphone" label="联系方式">
            </el-table-column>
          </el-table>
        </div>
        <div class="remark-box">
          <div style="color: white;margin: 10px 0">
            <span>是否有效通知：</span>
            <el-radio-group v-model="realtimeIsEffective">
              <el-radio :label="1">有效</el-radio>
              <el-radio :label="0">无效</el-radio>
            </el-radio-group>
          </div>
          <label style="color:white;">报警处理结果:</label>
          <el-input
            v-model="remarkText"
            type="text"
            :rows="1"
            placeholder="请输入处理结果"
            style="width:60%;margin-left:10px;"
          />
          <el-button
            type="success"
            round
            style="margin-left:10px;"
            @click="remarkTextChange(alarmData.cid)"
            >提交</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 紧急联系人查看 -->
    <el-dialog
      :visible.sync="sosLinkNameModal"
      @close="sosLinkNameModalCloseClick"
      width="700px"
      :center="true"
    >
      <div class="map-mark-dialog">
        <div class="person-top">
          <div class="person-photo">
            <img
              v-if="alarmData.headPic == null"
              src="../assets/images/defaultPhoto.png"
              alt=""
            />
            <img v-else :src="alarmData.headPic" alt="" />
          </div>
          <div id="memberId" style="display:none;">
            {{ memberNoticeData.memberId }}
          </div>
          <div class="other-info">
            <div class="other-info-top">
              <div class="primary-info">
                姓名: {{ memberNoticeData.realName }}
              </div>
            </div>
            <div class="primary-info">
              联系方式: {{ memberNoticeData.phoneNo }}
            </div>
            <div class="primary-info address-info" v-if="memberNoticeData.attr != '301'">
              报警位置: {{ memberNoticeData.address }}
            </div>
            <div class="primary-info address-info address-text" v-else>
              报警位置: {{ memberNoticeData.talkUrl}}
            </div>
          </div>
        </div>
        <div class="person-center" v-if="memberNoticeData.attr != '301'">
          {{ memberNoticeData.realName }}在{{
            memberNoticeData.address == null
              ? memberNoticeData.addrNo
              : memberNoticeData.address
          }}{{memberNoticeData.remark}}，请迅速检查
        </div>
        <div class="person-center" v-else>
          {{ memberNoticeData.realName }}
          {{ getAlarmDataTips(memberNoticeData.deviceType) }}
        </div>
        <div class="person-center" style="color:white;">紧急联系人</div>
        <div class=" person-end">
          <el-table
            :data="memberNoticeData.contacts"
            style="width: 100%;margin-bottom:10px;"
          >
            <el-table-column prop="name" label="姓名" width="100">
            </el-table-column>
            <el-table-column prop="relation" label="关系" width="100">
            </el-table-column>
            <el-table-column prop="telphone" label="联系方式">
            </el-table-column>
          </el-table>
          <!-- <div class="person-center person-contact" v-for="(item,index) in memberNoticeData.contacts" :key="index">
            <div class="contact-item">联系人:{{item.name}}</div>
            <div class="contact-item">关系:{{item.relation}}</div>
            <div class="contact-item">电话:{{item.telphone}}</div>
            <el-button style="margin-left:20px" icon="el-icon-phone" type="primary" circle size="small"></el-button>
          </div> -->
        </div>
        <div class="remark-box">
          <div style="color: white;margin: 10px 0">
            <span>是否有效通知：</span>
            <el-radio-group v-model="memberNoticeData.isEffective">
              <el-radio :label="1">有效</el-radio>
              <el-radio :label="0">无效</el-radio>
            </el-radio-group>
          </div>
          <div>
            <label style="color:white;">报警处理结果:</label>
            <el-input
              v-model="alarmHandleResult"
              type="text"
              :rows="1"
              placeholder="请输入处理结果"
              style="width:60%;margin-left:10px;"
            />
            <el-button
              type="success"
              round
              size="small"
              style="margin-left:10px;"
              @click="alarmHandleClick(memberNoticeData.cid)"
            >提交</el-button
            >
          </div>
          <div  style="margin-top: 12px;">
            <!--     处理记录     -->
            <label style="color:white;">报警处理记录:</label>

            <el-table
              :data="alarmHandleResultList"
              style="width: 100%;margin-bottom:10px;"
            >
              <el-table-column prop="handler" label="处理人" width="100">
              </el-table-column>
              <el-table-column prop="handleTime" label="处理时间" width="170">
              </el-table-column>
              <el-table-column prop="result" label="处理结果" show-overflow-tooltip>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 一键通话模态框 -->
    <div class="mydrawer" v-if="callDrawer">
      <div class="mydrawer-inner">
        <div class="mydrawer-head">
          <h3>与老人通话</h3>
          <div @click="closeMydrawer()"><i class="el-icon-close" /></div>
        </div>
        <div class="mydrawer-body">
          <div class="mydrawer-connent">
            <div class="person-top">
              <div class="person-photo">
                <img
                  v-if="currentObj.headPic == null"
                  src="../assets/images/defaultPhoto.png"
                  alt=""
                />
                <img v-else :src="currentObj.headPic" alt="" />
              </div>

              <div class="other-info">
                <div class="other-info-top">
                  <div class="primary-info rightspace">
                    {{ currentObj.age }}岁
                  </div>
                  <div class="primary-info">{{ currentObj.name }}</div>
                  <div class="primary-info sex-info">
                    {{ currentObj.genderView }}
                  </div>
                </div>
                <div class="primary-info address-info">
                  地址: {{ currentObj.address }}
                </div>
                <div class="primary-info address-info">
                  联系电话: {{ currentObj.phoneNo }}
                </div>
              </div>
            </div>
            <div class="real-call">
              <iframe
                v-if="callDrawer"
                id="talkSosCall"
                :src="talkSosUrl"
                frameborder="0"
                width="100%"
                height="100%"
                allow="camera *;microphone *"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from "@antv/g2";
import { Liquid, measureTextWidth, P } from "@antv/g2plot";
import { datasApi } from "@/api/dataApi.js";
import Vue from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";

import qs from "qs";
import { getDifferTime, getCurrentTime } from "@/utils/dateTimeUtil.js";
import {
  getMemberTag,
  getDisablityType,
  getLiveStatusType
} from "@/utils/analysisUtils.js";
import config from "@/config";
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from "echarts/core";
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, PieChart } from "echarts/charts";
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
  ToolboxComponent
} from "echarts/components";
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from "echarts/features";
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers";

import ReconnectingWebSocket from 'reconnecting-websocket';
import spinner from "element-ui/packages/spinner";

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  PieChart,
  LabelLayout,
  UniversalTransition,
  LegendComponent,
  ToolboxComponent,
  CanvasRenderer
]);

export default {
  name: "dashboard",
  computed: {
    spinner() {
      return spinner
    },
    homeTitle() {
      return config.homeTitle;
    }
  },
  data() {
    return {
      loginName: '',
      repoertsData: {},
      isSelectDay: true,
      alarmTotalData: {
        handleNum: 0,
        noHandleNum: 0,
        dayNum: 0,
        weekNum: 0,
        monthNum: 0,
        yearNum: 0
      }, //报警统计数据
      callDrawer: false,
      talkSosUrl: "",
      currentObj: {},
      sosLinkNameModal: false,
      memberNoticeData: {
        address: "",
        contacts: [],
        realName: ""
      },
      handleResult: "",
      remarkText: "",
      searchName: "",
      map: "",
      mapConfig: {
        center: [114.42,30.46],
        position: [114.42,30.46],
        zoom: 12,
        mapStyle: "amap://styles/darkblue"
      },
      flag: false,
      activeNameHealth: "liveHabit0",
      activeNameRecord: "healthCondition01",
      // 柱状图数据
      alertData: [
        { type: "A", cate: "115", title: "紧急呼叫", value: 0, monthValue: 0 },
        {
          type: "B",
          cate: "119",
          title: "生活习惯异常",
          value: 0,
          monthValue: 0
        },
        {
          type: "C",
          cate: "113",
          title: "环境--燃气",
          value: 0,
          monthValue: 0
        },
        {
          type: "D",
          cate: "116",
          title: "环境--烟雾",
          value: 0,
          monthValue: 0
        },
        {
          type: "E",
          cate: "117",
          title: "环境--水浸",
          value: 0,
          monthValue: 0
        },
        {
          type: "F",
          cate: "112",
          title: "环境--温度",
          value: 0,
          monthValue: 0
        },
        { type: "G", cate: "129", title: "跌倒监测", value: 0, monthValue: 0 },
        { type: "H", cate: "130", title: "健康指标", value: 0, monthValue: 0 },
        { type: "I", cate: "128", title: "尿床监测", value: 0, monthValue: 0 }
      ],
      // 机构下安装的设备
      devices: [],
      // 报警通知数据
      noticeData: [],
      // 人员列表数据
      memberList: [],
      memberAllList:[],
      markers: [],
      // 默认tabs
      activeName: "first",
      //选择的会员
      selectedMemberData: {},
      selectedAddress: "",
      dialogOldmanInfo: false,
      //生活习惯tabs
      lifeHabitTabs: ["主卧", "客厅", "次卧", "卫生间", "厨房", "阳台", "大门"],
      //监测指标,默认主卧
      monitoringDatas: [
        {
          controlTitle: "主卧今日进出",
          recordNumber: 0,
          type: "118"
        },
        {
          controlTitle: "主卧床边监测",
          recordNumber: 0,
          type: "119"
        },
        {
          controlTitle: "主卧夜灯",
          recordNumber: 0,
          type: "121"
        },
        {
          controlTitle: "智能水表",
          recordNumber: 0,
          type: "132"
        }
      ],
      selectLifeType: "118",
      selectTabTitle: "主卧",
      selectMonitorTitle: "主卧今日进出",
      selectMonIndex: 0,
      alertAlarmData: [
        { type: "A", cate: "115", title: "紧急呼叫", value: 0, monthValue: 0 },
        {
          type: "B",
          cate: "119",
          title: "生活习惯异常",
          value: 0,
          monthValue: 0
        },
        {
          type: "C",
          cate: "113",
          title: "环境--燃气",
          value: 0,
          monthValue: 0
        },
        {
          type: "D",
          cate: "116",
          title: "环境--烟雾",
          value: 0,
          monthValue: 0
        },
        {
          type: "E",
          cate: "117",
          title: "环境--水浸",
          value: 0,
          monthValue: 0
        },
        {
          type: "F",
          cate: "112",
          title: "环境--温度",
          value: 0,
          monthValue: 0
        },
        { type: "G", cate: "129", title: "跌倒监测", value: 0, monthValue: 0 },
        { type: "H", cate: "130", title: "健康指标", value: 0, monthValue: 0 },
        { type: "I", cate: "128", title: "尿床监测", value: 0, monthValue: 0 }
      ],
      memberAlertNotices: [],
      //老人健康数据
      healthTabsTitle: ["心跳", "呼吸", "在床状态"],
      selectHealthTabTitle: "心跳",
      healthMonitorData: [
        {
          controlTitle: "心跳",
          recordNumber: "0 次/分钟"
        }
      ],
      healthDataLists: [],
      barChart: null,
      habitDetailData: [],
      habitWaterDetailData: [], //水表详情数据
      selectMemberId: "",
      healthTitles: ["心跳", "呼吸", "在床状态"],
      clickMember: {
        memberInfo: {}
      },
      mapMarkerDailog: false,
      deviceNum: {deviceNum:0,hostNum:0},
      detailDevices: [],
      websocket: null,
      alarmDialogVisible: false,
      alarmData: {
        isEffective: 1,
      },
      audioPlayer: new Audio(require('../assets/alarm.mp3')),
      //老人详情信息
      olderDetailInfo: {},
      pageNum: 1,
      //报警结果处理
      alarmHandleResult: '',
      alarmHandleResultList: [],
      realtimeIsEffective: 1,
    };
  },
  mounted() {
    this.mapConfig = {
        center: config.centerLocation.split(','),
        position: config.centerLocation.split(','),
        zoom: 12,
        mapStyle: "amap://styles/darkblue"
    }
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.loginName = userInfo.realName
    // this.initAlterChart()
    this.initAlterPieChart();
    this.initDeviceChart();
    this.initMap();

    this.getAlarmTotalData();
    this.getAbnormalData();
    this.getAlarmData();
    this.getMemberList();
    this.getDeviceNumData();
    this.getDevicesNumData();
    this.initWebSocket();

    // 加载柱状图
    // this.initBarChart()
    // 加载设备工况运行天数
    this.getDays();
    // 加载设备工况看护天数
    this.getDays02();

    this.timer = setInterval(() => {
      // setTimeout(() => {

      this.$nextTick(() => {
        // 这里可以放置依赖于DOM更新后的操作
        this.getAlarmTotalData();
        this.getAbnormalData();
        this.getAlarmData();
        // this.getMemberList();
        this.getDeviceNumData();
        this.getDevicesNumData();
        this.websock.send("1");

      });
      // }, 0);
    }, 1000 * 120);
  },
  destroyed() {
    clearInterval(this.timer);
    this.websock.close(); //离开路由之后断开websocket连接
  },
  methods: {
    getAlarmDataTips(deviceType) {
      if (deviceType == 115 || deviceType == 302) {
        return "进行了紧急呼救求助";
      }
      if (deviceType == 116) {
        return "烟雾浓度超标,请检查是否发生火灾情况";
      }
      if (deviceType == 117) {
        return "水浸设备异常,请检查是否发生漏水情况";
      }
      if (deviceType == 113) {
        return "燃气浓度超标,请检查是否发生燃气泄露情况";
      }
      if (deviceType == 128) {
        return "尿床带异常,请及时查看老人情况";
      }
      if (deviceType == 129) {
        return "老人有跌倒情况,请及时查看老人情况";
      }
      if (deviceType == 130) {
        return "老人呼吸心率数据异常,请及时查看老人情况";
      }
      if (deviceType == 131 || deviceType == 302) {
        return "老人拨打了紧急呼救设备,请及时联系老人及家属";
      }
      if (deviceType == 132) {
        return "老人水表数据异常,请及时联系老人及家属";
      }
      if(deviceType == 301) {
        return "穿戴定位器发生报警";
      }

    },
    //websocket连接
    initWebSocket() {
      //初始化weosocket
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

      const wsuri = config.webUrl + userInfo.areaCodeSub + '__' + userInfo.userId;
      this.websock = new ReconnectingWebSocket(wsuri, null, {
        reconnectInterval: 3000,
      });

      this.websock.onopen = function() {
      }
      this.websock.onmessage = this.websocketonmessage

      this.websock.onclose = function() {
      }
    },
    webSocketSend() {
      //连接建立之后执行send方法发送数据
      this.websock.send("123456");
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      //数据接收
      const redata = JSON.parse(e.data);
      this.alarmData = redata;
      this.alarmData.isEffective = 1;
      this.alarmDialogVisible = true;
      this.$nextTick(() => {
        this.playAudio();
        this.getAbnormalData();
        this.getAlarmData();
        this.getMemberList();
      })
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    websocketclose(e) {
      //关闭
    },
    //退出登录
    handleCommand(command) {
      if (command == "out") {
        sessionStorage.setItem("isLogin", null);
        if (config.sso == '1') {
          const ssoUrl = config.ssoUrl;
          datasApi
            .ssoLogOut()
            .then(res => {
              location.href = ssoUrl;
            })
            .catch(err => {
              this.$message.error("系统异常");
            });
        }else {
          this.$router.push('/login')
        }
      }
    },
    /**智能看护柱状图 */
    initAlterChart() {
      var chartDom = document.getElementById("alarmChart");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["今日", "本月"]
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            // prettier-ignore
            data: ['紧急呼叫', '烟雾', '水浸', '燃气', '温度', '跌倒监测', '尿床监测', '健康指标','生活习惯异常']
          }
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false
            }
          }
        ],

        series: [
          {
            name: "今日",
            type: "bar",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          },
          {
            name: "本月",
            type: "bar",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      };
      myChart.setOption(option);
    },
    /** 数据饼图 */
    initAlterPieChart() {
      var chartDom = document.getElementById("pieChart");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
          textStyle: {
            fontSize: 10
          }
        },
        series: [
          {
            name: "报警",
            type: "pie",
            radius: [20, 60],
            center: ["50%", "60%"],
            roseType: "area",
            itemStyle: {
              borderRadius: 0,
              normal: {
                label: {
                  color: "inherit",
                  textStyle: {
                    fontWeight: "normal",
                    fontSize: 10
                  }
                }
              }
            },

            data: [
              { value: 0, name: "紧急呼叫" },
              { value: 0, name: "烟雾" },
              { value: 0, name: "水浸" },
              { value: 0, name: "燃气" },
              { value: 0, name: "温度" },
              { value: 0, name: "跌倒监测" },
              { value: 0, name: "尿床监测" },
              { value: 0, name: "健康指标" },
              { value: 0, name: "生活习惯异常" }
            ]
          }
        ]
      };
      myChart.setOption(option);
    },

    updatePieChart(index) {
      let data = [];
      let today = this.repoertsData.data.today;
      let month = this.repoertsData.data.month;
      if (index == 0) {
        this.isSelectDay = true;
        data = [
          { value: today.sos, name: "紧急呼叫" },
          { value: today.smoke, name: "烟雾" },
          { value: today.waterOut, name: "水浸" },
          { value: today.gas, name: "燃气" },
          { value: today.temperature, name: "温度" },
          { value: today.fallDown, name: "跌倒监测" },
          { value: today.enuresis, name: "尿床监测" },
          { value: today.healthStatus, name: "健康指标" },
          { value: today.activity, name: "生活习惯异常" }
        ];
      } else {
        this.isSelectDay = false;
        data = [
          { value: month.sos, name: "紧急呼叫" },
          { value: month.smoke, name: "烟雾" },
          { value: month.waterOut, name: "水浸" },
          { value: month.gas, name: "燃气" },
          { value: month.temperature, name: "温度" },
          { value: month.fallDown, name: "跌倒监测" },
          { value: month.enuresis, name: "尿床监测" },
          { value: month.healthStatus, name: "健康指标" },
          { value: month.activity, name: "生活习惯异常" }
        ];
      }

      //刷新玫瑰图数据
      let piechart = echarts.getInstanceByDom(
        document.getElementById("pieChart")
      );
      let pieoption = piechart.getOption();
      pieoption.series[0].data = data;
      piechart.setOption(pieoption);
    },

    /**老人详情数据 */
    initMemberAlterChart() {
      var chartDom = document.getElementById("memberAlterChart");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["今日", "本月"]
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            // prettier-ignore
            data: ['紧急呼叫', '烟雾', '水浸', '燃气', '温度', '跌倒监测', '尿床监测', '健康指标','生活习惯异常']
          }
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "今日",
            type: "bar",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          },
          {
            name: "本月",
            type: "bar",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      };
      myChart.setOption(option);
    },
    /**设备统计柱状图 */
    initDeviceChart() {
      var chartDom = document.getElementById("deviceChart");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        // legend: {},
        grid: {
          top: "0px",
          left: "0px",
          right: "0px",
          bottom: "0px",
          containLabel: true
        },
        xAxis: {
          type: "value",
          // boundaryGap: [0, 0.01]
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: "category",
          data: [
            "呼叫器",
            "烟感",
            "水浸",
            "门磁",
            "红外",
            "床垫",
            "燃气",
            "温感",
            "智能水表",
            "尿床带"
          ]
        },
        series: [
          {
            type: "bar",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      };
      myChart.setOption(option);
    },
    /*获取智能看护报告数据 */
    getAbnormalData() {
      let params = {
        areaCode: JSON.parse(sessionStorage.getItem("userInfo")).areaCode
      };
      datasApi
        .getAbnormalData(params)
        .then(res => {
          this.repoertsData = res;
          let device = res.data.devices;
          let today = res.data.today;
          let month = res.data.month;
          // ['紧急呼叫', '烟雾', '水浸', '燃气', '温度', '跌倒监测', '尿床监测', '健康指标','生活习惯异常']
          let todayData = [
            today.sos,
            today.smoke,
            today.waterOut,
            today.gas,
            today.temperature,
            today.fallDown,
            today.enuresis,
            today.healthStatus,
            today.activity
          ];
          let monthData = [
            month.sos,
            month.smoke,
            month.waterOut,
            month.gas,
            month.temperature,
            month.fallDown,
            month.enuresis,
            month.healthStatus,
            month.activity
          ];
          let pieData = [
            { value: today.sos, name: "紧急呼叫" },
            { value: today.smoke, name: "烟雾" },
            { value: today.waterOut, name: "水浸" },
            { value: today.gas, name: "燃气" },
            { value: today.temperature, name: "温度" },
            { value: today.fallDown, name: "跌倒监测" },
            { value: today.enuresis, name: "尿床监测" },
            { value: today.healthStatus, name: "健康指标" },
            { value: today.activity, name: "生活习惯异常" }
          ];
          // 刷新图表数据
          // let chart = echarts.getInstanceByDom(document.getElementById('alarmChart'))
          // let option = chart.getOption()
          // option.series[0].data = todayData
          // option.series[1].data = monthData
          // chart.setOption(option)

          //刷新玫瑰图数据
          let piechart = echarts.getInstanceByDom(
            document.getElementById("pieChart")
          );
          let pieoption = piechart.getOption();
          pieoption.series[0].data = pieData;
          piechart.setOption(pieoption);

          this.updatePieChart(0);

          this.devices.push(...device);
          this.alertData = [
            {
              type: "A",
              cate: "115",
              title: "紧急呼叫",
              value: today.sos,
              monthValue: month.sos
            },
            {
              type: "B",
              cate: "119",
              title: "生活习惯异常",
              value: today.activity,
              monthValue: month.activity
            },
            {
              type: "C",
              cate: "113",
              title: "环境--燃气",
              value: today.gas,
              monthValue: month.gas
            },
            {
              type: "D",
              cate: "116",
              title: "环境--烟雾",
              value: today.smoke,
              monthValue: month.smoke
            },
            {
              type: "E",
              cate: "117",
              title: "环境--水浸",
              value: today.waterOut,
              monthValue: month.waterOut
            },
            {
              type: "F",
              cate: "112",
              title: "环境--温度",
              value: today.temperature,
              monthValue: month.temperature
            },
            {
              type: "G",
              cate: "129",
              title: "跌倒监测",
              value: today.fallDown,
              monthValue: month.fallDown
            },
            {
              type: "H",
              cate: "130",
              title: "健康指标",
              value: today.healthStatus,
              monthValue: month.healthStatus
            },
            {
              type: "I",
              cate: "128",
              title: "尿床监测",
              value: today.enuresis,
              monthValue: month.enuresis
            }
          ];
          this.barChart.changeData(this.alertData);
        })
        .catch(err => {});
    },
    /**获取报警数据统计 */
    getAlarmTotalData() {
      let params = {
        areaCode: JSON.parse(sessionStorage.getItem("userInfo")).areaCode
      };
      datasApi
        .getAlarmTotalData(params)
        .then(res => {
          if (res.code == 1) {
            this.alarmTotalData = res.data;
          }
        })
        .catch(err => {});
    },
    /** 获取设备统计数据 */
    getDevicesNumData() {
      let params = {
        areaCode: JSON.parse(sessionStorage.getItem("userInfo")).areaCode
      };
      datasApi
        .getDevicesNumData(params)
        .then(res => {
          if (res.code == 1) {
            //['一键呼救', '烟感', '水浸', '门磁', '红外', '床垫','燃气','语音呼救','智能水表','尿床带']
            let resData = res.data;
            let deviceData = [
              resData.sosNum,
              resData.yanwuNum,
              resData.shuijinNum,
              resData.menciNum,
              resData.hongwaiNum,
              resData.chuangdianNum,
              resData.ranqiNum,
              resData.wenganNum,
              resData.shuibiaoNum,
              resData.niaochuangdaiNum
            ];
            //刷新图标数据
            let chart = echarts.getInstanceByDom(
              document.getElementById("deviceChart")
            );
            let option = chart.getOption();
            option.series[0].data = deviceData;
            chart.setOption(option);
          }
        })
        .catch(err => {});
    },
    /**获取报警通知*/
    getAlarmData() {
      this.pageNum = 1
      let params = {
        areaCode: JSON.parse(sessionStorage.getItem("userInfo")).areaCode,
        pageNum: this.pageNum,
        pageSize: 50
      };
      datasApi
        .getAlarmData(params)
        .then(res => {
          this.noticeData = [];
          this.noticeData.push(...res.data);
        })
        .catch(err => {});
    },
    searchMoreClick() {
      this.pageNum += 1
      let params = {
        areaCode: JSON.parse(sessionStorage.getItem("userInfo")).areaCode,
        pageNum: this.pageNum,
        pageSize: 50
      };
      datasApi
        .getAlarmData(params)
        .then(res => {
          this.noticeData.push(...res.data);
        })
        .catch(err => {});
    },
    //获取人员列表
    getMemberList() {
      let params = {
        areaCode: JSON.parse(sessionStorage.getItem("userInfo")).areaCode,
        search: this.searchName
      };
      datasApi
        .getMemberListData(params)
        .then(res => {
          this.memberList = [];
          this.memberAllList = []
          this.memberAllList.push(...res.data);
          this.getMemberListPage(1,10)
          this.getAddressLongAndLat();
          let nowDate = getCurrentTime();
          for (let index = 0; index < this.memberList.length; index++) {
            let item = this.memberList[index];
            Vue.set(
              item,
              "allDevice",
              this.createAllDevice(item.devices.split(","))
            );
            if (item.devices.indexOf("131") > -1) {
              let isCallHelper =
                item.devices.indexOf("131") > -1 ? true : false;
              let alarmTime = item.talkUrlVo ? item.talkUrlVo.alarmTime : '';
              if (getDifferTime(nowDate, alarmTime) > 29) {
                isCallHelper = false;
              } else {
                isCallHelper = true;
              }
              Vue.set(item, "isCallHelper", isCallHelper);
            }
          }
          this.getDays02();
        })
        .catch(err => {});
    },
    //老人列表分页
    getMemberListPage(pageNum,pageSize) {
      this.memberList = [];
      this.memberAllList.forEach((item,index) => {
        if (index < pageNum * pageSize && index >= (pageNum-1) * pageSize) {
          this.memberList.push(item)
        }
      })
    },
    pageChange(page) {
      this.memberList = [];
      this.getMemberListPage(page,10)
      let nowDate = getCurrentTime();
      for (let index = 0; index < this.memberList.length; index++) {
        let item = this.memberList[index];
        Vue.set(
          item,
          "allDevice",
          this.createAllDevice(item.devices.split(","))
        );
        if (item.devices.indexOf("131") > -1) {
          let isCallHelper =
            item.devices.indexOf("131") > -1 ? true : false;
          let alarmTime = item.talkUrlVo ? item.talkUrlVo.alarmTime : '';
          if (getDifferTime(nowDate, alarmTime) > 29) {
            isCallHelper = false;
          } else {
            isCallHelper = true;
          }
          Vue.set(item, "isCallHelper", isCallHelper);
        }
      }
    },
    //搜索
    searchMember() {
      this.getMemberList();
    },
    inputChangeClick(value) {
      this.getMemberList();
    },
    //获取老人报警数据
    getMemberAbnomarlData(memberId) {
      let params = {
        memberId: memberId
      };
      datasApi
        .getMemberAbnomarlData(params)
        .then(res => {
          let today = res.data.today;
          let month = res.data.month;

          // ['紧急呼叫', '烟雾', '水浸', '燃气', '温度', '跌倒监测', '尿床监测', '健康指标','生活习惯异常']
          let todayData = [
            today.sos,
            today.smoke,
            today.waterOut,
            today.gas,
            today.temperature,
            today.fallDown,
            today.enuresis,
            today.healthStatus,
            today.activity
          ];
          let monthData = [
            month.sos,
            month.smoke,
            month.waterOut,
            month.gas,
            month.temperature,
            month.fallDown,
            month.enuresis,
            month.healthStatus,
            month.activity
          ];
          // 刷新图表数据
          let chart = echarts.getInstanceByDom(
            document.getElementById("memberAlterChart")
          );
          let option = chart.getOption();
          option.series[0].data = todayData;
          option.series[1].data = monthData;
          chart.setOption(option);

          this.detailDevices = [];
          this.detailDevices.push(...res.data.devices);
          this.alertAlarmData = [
            {
              type: "A",
              cate: "115",
              title: "紧急呼叫",
              value: today.sos,
              monthValue: month.sos
            },
            {
              type: "B",
              cate: "119",
              title: "生活习惯异常",
              value: today.activity,
              monthValue: month.activity
            },
            {
              type: "C",
              cate: "113",
              title: "环境--燃气",
              value: today.gas,
              monthValue: month.gas
            },
            {
              type: "D",
              cate: "116",
              title: "环境--烟雾",
              value: today.smoke,
              monthValue: month.smoke
            },
            {
              type: "E",
              cate: "117",
              title: "环境--水浸",
              value: today.waterOut,
              monthValue: month.waterOut
            },
            {
              type: "F",
              cate: "112",
              title: "环境--温度",
              value: today.temperature,
              monthValue: month.temperature
            },
            {
              type: "G",
              cate: "129",
              title: "跌倒监测",
              value: today.fallDown,
              monthValue: month.fallDown
            },
            {
              type: "H",
              cate: "130",
              title: "健康指标",
              value: today.healthStatus,
              monthValue: month.healthStatus
            },
            {
              type: "I",
              cate: "128",
              title: "尿床监测",
              value: today.enuresis,
              monthValue: month.enuresis
            }
          ];
        })
        .catch(err => {});
    },
    //获取老人报警通知
    getMemberNotifData(memberId) {
      let params = {
        memberId: memberId
      };
      datasApi
        .getMemberNotifData(params)
        .then(res => {
          this.memberAlertNotices.push(...res.data);
        })
        .catch(err => {});
    },
    //获取老人健康数据
    getHealthType(title) {
      let type = "heartbeat";
      if (title == "心跳") {
        type = "heartbeat";
      }
      if (title == "呼吸") {
        type = "pneusis";
      }
      if (title == "在床状态") {
        type = "weight";
      }
      if (title == "头位") {
        type = "headPosition";
      }
      if (title == "胸位") {
        type = "chestPosition";
      }
      if (title == "尿湿") {
        type = "wet";
      }
      return type;
    },
    getMemberHealthData(memberId) {
      let params = {
        memberId: memberId,
        type: this.getHealthType(this.selectHealthTabTitle)
      };
      datasApi
        .getMemberHealthData(params)
        .then(res => {
          this.filterHealthData(res.data, this.selectHealthTabTitle);
        })
        .catch(err => {});
    },
    //
    getMemberDetailData(memberId) {
      let params = {
        memberId: memberId
      };
      datasApi
        .getMemberDetailData(params)
        .then(res => {
          //生活监测数据,默认返回主卧的数据
          let lifeHabitRes = res.data.lifeHabit;
          this.monitoringDatas = [
            {
              controlTitle: "主卧今日进出",
              recordNumber: lifeHabitRes.inOrOutNum,
              type: "118"
            },
            {
              controlTitle: "主卧床边监测",
              recordNumber: lifeHabitRes.activityNum,
              type: "119"
            },
            {
              controlTitle: "主卧夜灯",
              recordNumber: lifeHabitRes.nightNum,
              type: "121"
            },
            {
              controlTitle: "智能水表",
              recordNumber: 0,
              type: "132"
            }
          ];
          Vue.set(this.monitoringDatas, mainDoor);
          Vue.set(this.dialogData, "alertNotices", res.data.alarm);
          if (res.data && res.data.health.length > 0) {
            Vue.set(
              this.dialogData,
              "healthCondition",
              this.filterHealthData(res.data.health)
            );
          }
          let liveHabitDatas = [];
          for (let index = 0; index < lifeHabitRes.length; index++) {
            const element = lifeHabitRes[index];
            let item = {
              simpleName: index.toString(),
              lifeHabitTitle: element.lifeHabitTitle,
              controlNum: this.createControlNum(element)
            };
            liveHabitDatas.push(item);
          }
        })
        .catch(err => {});
    },
    //获取生活习惯数据
    getLifeHabitData(addrNo, memberId, type) {
      let params = {
        memberId: memberId,
        addrNo: addrNo,
        type: type
      };
      if (type === "132") {
        params = {
          memberId: memberId,
          type: type
        };
        datasApi
          .getLifeHabitWaterData(params)
          .then(res => {
            this.habitWaterDetailData = [];
            this.habitWaterDetailData.push(...res.data.list);
          })
          .catch(err => {});
      } else {
        datasApi
          .getLifeHabitData(params)
          .then(res => {
            this.habitDetailData = [];
            this.lifeFormatting(addrNo, res.data.num);
            this.habitDetailData.push(...res.data.list);
          })
          .catch(err => {});
      }
    },
    //tab子项点击
    subLifeClic(item, index) {
      this.selectMonIndex = index;
      this.selectMonitorTitle = item.controlTitle;
      this.habitDetailData = [];
      this.getLifeHabitData(
        this.selectTabTitle,
        this.selectMemberId,
        item.type
      );
    },
    // 生活习惯数据格式化
    lifeFormatting(addrNo, item) {
      if (addrNo == "主卧") {
        this.monitoringDatas = [
          {
            controlTitle: "主卧今日进出",
            recordNumber: item == null ? 0 : item.inOrOutNum,
            type: "118"
          },
          {
            controlTitle: "主卧床边监测",
            recordNumber: item == null ? 0 : item.activityNum,
            type: "119"
          },
          {
            controlTitle: "主卧夜灯",
            recordNumber: item == null ? 0 : item.nightNum,
            type: "121"
          },
          {
            controlTitle: "智能水表",
            recordNumber: item == null ? 0 : item.nightNum,
            type: "132"
          }
        ];
      }
      if (addrNo == "客厅") {
        this.monitoringDatas = [
          {
            controlTitle: "客厅活动",
            recordNumber: item == null ? 0 : item.activityNum,
            type: "119"
          },
          {
            controlTitle: "客厅夜灯",
            recordNumber: item == null ? 0 : item.nightNum,
            type: "121"
          }
        ];
      }
      if (addrNo == "次卧") {
        this.monitoringDatas = [
          {
            controlTitle: "次卧今日进出",
            recordNumber: item == null ? 0 : item.inOrOutNum,
            type: "118"
          },
          {
            controlTitle: "次卧床边监测",
            recordNumber: item == null ? 0 : item.activityNum,
            type: "119"
          },
          {
            controlTitle: "次卧夜灯",
            recordNumber: item == null ? 0 : item.nightNum,
            type: "121"
          }
        ];
      }
      if (addrNo == "卫生间") {
        this.monitoringDatas = [
          {
            controlTitle: "卫生间今日进出",
            recordNumber: item == null ? 0 : item.inOrOutNum,
            type: "118"
          },
          {
            controlTitle: "卫生间夜灯",
            recordNumber: item == null ? 0 : item.nightNum,
            type: "121"
          }
        ];
      }
      if (addrNo == "厨房") {
        this.monitoringDatas = [
          {
            controlTitle: "厨房今日进出",
            recordNumber: item == null ? 0 : item.inOrOutNum,
            type: "118"
          }
        ];
      }
      if (addrNo == "阳台") {
        this.monitoringDatas = [
          {
            controlTitle: "阳台今日进出",
            recordNumber: item == null ? 0 : item.inOrOutNum,
            tyep: "118"
          }
        ];
      }
      if (addrNo == "大门") {
        this.monitoringDatas = [
          {
            controlTitle: "大门今日进出",
            recordNumber: item == null ? 0 : item.inOrOutNum,
            type: "118"
          }
        ];
      }
    },
    //状态显示不同指标
    stateFormat(row) {
      if (this.selectMonitorTitle == "主卧今日进出") {
        if (row.state == 1) {
          return "主卧打开";
        } else {
          return "主卧关闭";
        }
      } else if (this.selectMonitorTitle == "次卧今日进出") {
        if (row.state == 1) {
          return "次卧打开";
        } else {
          return "次卧关闭";
        }
      } else if (this.selectMonitorTitle == "厨房今日进出") {
        if (row.state == 1) {
          return "厨房打开";
        } else {
          return "厨房关闭";
        }
      } else if (this.selectMonitorTitle == "阳台今日进出") {
        if (row.state == 1) {
          return "阳台打开";
        } else {
          return "阳台关闭";
        }
      } else if (this.selectMonitorTitle == "卫生间今日进出") {
        if (row.state == 1) {
          return "卫生间打开";
        } else {
          return "卫生间关闭";
        }
      } else if (this.selectMonitorTitle == "大门今日进出") {
        if (row.state == 1) {
          return "大门打开";
        } else {
          return "大门关闭";
        }
      }
      return this.selectMonitorTitle;
    },
    stateHealthFormat(row) {
      if (this.selectHealthTabTitle == "心跳") {
        return "心跳";
      }
      if (this.selectHealthTabTitle == "呼吸") {
        return "呼吸";
      }
      if (this.selectHealthTabTitle == "在床状态") {
        return "在床状态";
      }
      if (this.selectHealthTabTitle == "头位") {
        return "头位";
      }
      if (this.selectHealthTabTitle == "胸位") {
        return "胸位";
      }
      if (this.selectHealthTabTitle == "尿湿") {
        return "尿湿";
      }
    },
    //获取在线设备数目
    getDeviceNumData() {
      let params = {
        areaCode: JSON.parse(sessionStorage.getItem("userInfo")).areaCode
      };
      datasApi
        .getDeviceNumData(params)
        .then(res => {
          if (res.data) {
            this.deviceNum = res.data;
          }
        })
        .catch(err => {});
    },
    createAllDevice(device) {
      let allDevice = [];
      let all = [
        "一键呼救",
        "烟感",
        "水浸",
        "门磁",
        "红外",
        "床垫",
        "燃气",
        "语音呼救",
        "智能水表",
        "尿床带",
        "跌倒监测设备",
        "穿戴定位器",
        "语音报警按钮"
      ];
      let hasDevices = [];
      for (let index = 0; index < device.length; index++) {
        const element = device[index];
        hasDevices.push(this.getDeviceName(parseInt(element)));
      }
      for (let index = 0; index < all.length; index++) {
        const item = all[index];
        let on = false;
        if (hasDevices.indexOf(item) != -1) {
          on = true;
        } else {
          on = false;
        }
        let deviceOn = {
          deviceTitle: item,
          deviceOn: on
        };
        allDevice.push(deviceOn);
      }
      return allDevice;
    },
    getDeviceName(deviceType) {
      let deviceTitle = "";
      switch (deviceType) {
        case 114:
          deviceTitle = "床垫";
          break;
        case 115:
          deviceTitle = "一键呼救";
          break;
        case 116:
          deviceTitle = "烟感";
          break;
        case 117:
          deviceTitle = "水浸";
          break;
        case 119:
          deviceTitle = "红外";
          break;
        case 111:
          deviceTitle = "温湿度";
          break;
        case 112:
          deviceTitle = "温度";
          break;
        case 118:
          deviceTitle = "门磁";
          break;
        case 113:
          deviceTitle = "燃气";
          break;
        case 114:
          deviceTitle = "床垫";
          break;
        case 121:
          deviceTitle = "夜灯";
          break;
        case 128:
          deviceTitle = "尿床带";
          break;
        case 129:
          deviceTitle = "跌倒监测设备";
          break;
        case 130:
          deviceTitle = "呼吸心率设备";
          break;
        case 132:
          deviceTitle = "智能水表";
          break;
        case 131:
          deviceTitle = "语音呼救";
          break;
        case 301:
          deviceTitle = "穿戴定位器";
          break;
        case 302:
          deviceTitle = "语音报警按钮";
          break;
        default:
          break;
      }
      return deviceTitle;
    },
    getNoticeTips(deviceType) {
      let tips = "";
      switch (deviceType) {
        case 115:
          tips = "紧急呼救异常提示";
          break;
        case 116:
          tips = "烟感异常提示";
          break;
        case 117:
          tips = "水浸异常提示";
          break;
        case 119:
          tips = "生活习惯异常提示";
          break;
        case 111:
          tips = "温湿度异常提示";
          break;
        case 112:
          tips = "温度异常提示";
          break;
        case 118:
          tips = "门磁设备异常提示";
          break;
        case 113:
          tips = "燃气设备异常提示";
          break;
        case 114:
          tips = "床垫设备异常提示";
          break;
        case 121:
          tips = "夜灯设备异常提示";
          break;
        case 128:
          tips = "尿床带设备异常";
          break;
        case 129:
          tips = "跌倒监测设备异常";
          break;
        case 131:
          tips = "老人拨打语音呼救";
          break;
        case 130:
          tips = "呼吸心率设备异常";
          break;
        case 132:
          tips = "智能水表设备异常";
          break;
        default:
          break;
      }
      return tips;
    },
    //健康数据筛选
    filterHealthData(healthData, type) {
      if (type == "心跳") {
        this.healthMonitorData = [
          {
            controlTitle: "心跳",
            recordNumber:
              healthData.length == 0 ? "0" : healthData[0].heartbeat + "次/分钟"
          }
        ];
      }
      if (type == "呼吸") {
        this.healthMonitorData = [
          {
            controlTitle: "呼吸",
            recordNumber:
              healthData.length == 0 ? "0" : healthData[0].pneusis + "次/分钟"
          }
        ];
      }
      if (type == "在床状态") {
        this.healthMonitorData = [
          {
            controlTitle: "在床状态",
            recordNumber:
              healthData.length == 0
                ? "离床"
                : this.onBeedStatus(healthData[0].weight)
          }
        ];
      }
      if (type == "头位") {
        this.healthMonitorData = [
          {
            controlTitle: "头位",
            recordNumber:
              healthData.length == 0 ? "0" : healthData[0].headPosition
          }
        ];
      }
      if (type == "胸位") {
        this.healthMonitorData = [
          {
            controlTitle: "胸位",
            recordNumber:
              healthData.length == 0 ? "0" : healthData[0].chestPosition
          }
        ];
      }
      if (type == "尿湿") {
        this.healthMonitorData = [
          {
            controlTitle: "尿湿",
            recordNumber: healthData.length == 0 ? "0" : healthData[0].wet
          }
        ];
      }
      //健康数据
      this.healthDataLists.push(...healthData);
    },
    // 健康数据列表
    createHealthNewsData(healthData, title) {
      let datasArray = [];
      for (let index = 0; healthData < array.length; index++) {
        const element = healthData[index];
        let item = {};
        if (title == "心跳") {
          item = {
            controlTitle: title,
            recordNumber:
              element.heartbeat == null ? "0" : element.heartbeat + "次/分钟",
            controlTime: element.dataTime
          };
        } else if (title == "呼吸") {
          item = {
            controlTitle: title,
            recordNumber:
              element.pneusis == null ? "0" : element.pneusis + "次/分钟",
            controlTime: element.dataTime
          };
        } else if (title == "在床状态") {
          item = {
            controlTitle: title,
            recordNumber: this.onBeedStatus(element.weight),
            controlTime: element.dataTime
          };
        } else if (title == "头位") {
          item = {
            controlTitle: title,
            recordNumber:
              element.headPosition == null ? "0" : element.headPosition,
            controlTime: element.dataTime
          };
        } else if (title == "胸位") {
          item = {
            controlTitle: title,
            recordNumber:
              element.chestPosition == null ? "0" : element.chestPosition,
            controlTime: element.dataTime
          };
        } else if (title == "尿湿") {
          item = {
            controlTitle: title,
            recordNumber: element.wet == null ? "0" : element.wet,
            controlTime: element.dataTime
          };
        }
        datasArray.push(item);
      }
    },
    //返回在床状态
    onBeedStatus(flag) {
      let str = "离床";
      switch (flag) {
        case 0:
          str = "离床";
          break;
        case 1:
          str = "在床";
          break;
        case 2:
          str = "体动";
          break;
        case 7:
          str = "呼吸暂停";
          break;
        case 9:
          str = "呼吸暂停";
          break;

        default:
          break;
      }
      return str;
    },
    // 老人详细信息
    goToDetail(item) {
      this.selectMemberId = item.memberId;
      this.selectedAddress = item.address;
      this.selectedMemberData = item;
      //获取老人详细信息
      this.getOlderDetailInfo(item.memberId);
      this.getMemberAbnomarlData(item.memberId);
      this.getMemberNotifData(item.memberId);
      this.getMemberHealthData(item.memberId);
      this.dialogOldmanInfo = true;
      this.selectMonitorTitle = "主卧今日进出";
      this.getLifeHabitData("主卧", item.memberId, "118");
    },
    memberOpened() {
      this.initMemberAlterChart();
    },
    //查询老人详情信息
    getOlderDetailInfo(memberId) {
      let params = {
        memberId: memberId
      };
      datasApi
        .getOlderDetialInfo(params)
        .then(res => {
          this.olderDetailInfo = res.data;
        })
        .catch(err => {});
    },
    //生活习惯选项卡选择
    tabHandleClick(tab, event) {
      this.selectTabTitle = tab.label;
      this.selectMonIndex = 0;
      this.habitDetailData = [];
      this.lifeFormatting(this.selectTabTitle, null);
      this.selectMonitorTitle = this.monitoringDatas[
        this.selectMonIndex
      ].controlTitle;
      this.selectLifeType = this.monitoringDatas[this.selectMonIndex].type;
      this.getLifeHabitData(
        tab.label,
        this.selectMemberId,
        this.selectLifeType
      );
    },
    //健康选项卡切换
    tabHandleHealthClick(tab, event){
      this.selectHealthTabTitle = tab.label;
      this.healthDataLists = [];
      this.getMemberHealthData(this.selectMemberId);
    },
    // 根据经纬度进行定位
    getAddressLongAndLat() {
      let that = this;
      this.map.remove(this.markers);
      this.markers = [];
      // let geocoder = new AMap.Geocoder({
      //   city: '武汉市'
      // })
      this.map.setCenter([
        this.memberList[0].longitude ? this.memberList[0].longitude : config.centerLocation.split(',')[0],
        this.memberList[0].latitude ? this.memberList[0].latitude : config.centerLocation.split(',')[1]
      ]);

      for (let i = 0; i < this.memberList.length; i++) {
        let longitude =
          this.memberList[i].longitude == null
            ? "114.44472"
            : this.memberList[i].longitude;
        let latitude =
          this.memberList[i].latitude == null
            ? this.memberList[0].latitude + 0.001
            : this.memberList[i].latitude;
        var text = new AMap.Text({
          text: this.memberList[i].name,
          extData: i,
          anchor: "center", // 设置文本标记锚点
          draggable: false,
          cursor: "pointer",
          clickable: true,
          style: {
            "margin-bottom": "1rem",
            "border-radius": ".25rem",
            "background-color": "#3b54d3",
            width: "60px",
            "border-width": 0,
            "box-shadow": "0 2px 6px 0 rgba(114, 124, 245, .5)",
            "text-align": "center",
            "font-size": "12px",
            color: "white"
          },
          position: [longitude, latitude]
        });
        text.on("click", function(e) {
          //显示弹窗
          that.clickMember = that.memberList[i];
          that.mapMarkerDailog = true;
        });
        text.setMap(that.map);
        that.markers.push(text);
      }
      //   const element = this.memberList[i];
      //   let address = element.address
      //   if(address.length > 0){
      //   }else{
      //     address ='湖北省武汉市'
      //   }
      //   geocoder.getLocation(address, function(status, result) {
      //     if (status === 'complete' && result.geocodes.length > 0) {

      //       that.map.setCenter([result.geocodes[0].location.lng,result.geocodes[0].location.lat])
      //
      //   })
      // }
    },
    //老人详情弹窗关闭
    memberDialogClose() {
      this.selectTabTitle = "主卧";
      this.selectMonIndex = 0;
      this.habitDetailData = [];
      this.selectHealthTabTitle = "心跳";
      this.healthDataLists = [];
      this.memberAlertNotices = [];
      this.alertAlarmData = [
        { type: "A", cate: "115", title: "紧急呼叫", value: 0, monthValue: 0 },
        {
          type: "B",
          cate: "119",
          title: "生活习惯异常",
          value: 0,
          monthValue: 0
        },
        {
          type: "C",
          cate: "113",
          title: "环境--燃气",
          value: 0,
          monthValue: 0
        },
        {
          type: "D",
          cate: "116",
          title: "环境--烟雾",
          value: 0,
          monthValue: 0
        },
        {
          type: "E",
          cate: "117",
          title: "环境--水浸",
          value: 0,
          monthValue: 0
        },
        {
          type: "F",
          cate: "112",
          title: "环境--温度",
          value: 0,
          monthValue: 0
        },
        { type: "G", cate: "129", title: "跌倒监测", value: 0, monthValue: 0 },
        { type: "H", cate: "130", title: "健康指标", value: 0, monthValue: 0 },
        { type: "I", cate: "128", title: "尿床监测", value: 0, monthValue: 0 }
      ];
    },
    // 柱状图
    initBarChart() {
      const chart = new Chart({
        container: "mybar",
        autoFit: true,
        padding: [10, 10, 30, 10]
      });
      chart.data(this.alertData);
      chart.scale("value", {
        alias: "异常与报警提示"
      });

      chart.axis("type", {
        tickLine: {
          alignTick: false
        }
      });
      chart.axis("value", false);

      chart.tooltip({
        showMarkers: false
      });
      chart.interval().position("type*value");
      chart.interaction("element-active");

      // 添加文本标注
      this.alertData.forEach(item => {
        chart.annotation().text({
          position: [item.type, item.value],
          content: item.value,
          style: {
            textAlign: "center",
            fontFamily: "#fff"
          },
          offsetY: -5
        });
      });
      chart
        .interval()
        .position("type*value")
        .color("l(90) 0:#7e2dca 1:#0096e4"); // 定义柱状图渐变色
      chart.render();
      this.barChart = chart;
    },
    //初始化地图
    initMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "b84ffd5c856cd006e30e25286b6fee75",
      };
      AMapLoader.load({
        key: "047e86eb3d220d90162373c90fd6c7f3", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", this.mapConfig);
        })
        .catch((e) => {
          console.log(e);
        });
      // this.map = new AMap.Map("container", this.mapConfig);
      // AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function () {
      //   that.map.addControl(new AMap.ToolBar())
      //   that.map.addControl(new AMap.Scale())
      // })
    },
    // 设备工况运行天数
    getDays() {
      var s1 = "2023-06-01";
      s1 = new Date(s1.replace(/-/g, "/"));
      var s2 = new Date(); //当前日期：2017-04-24
      var days = s2.getTime() - s1.getTime();
      var time = parseInt(days / (1000 * 60 * 60 * 24));
      const liquidPlot = new Liquid(document.getElementById("days01"), {
        percent: 0.8,
        radius: 1,
        statistic: {
          title: {
            formatter: () => "运行",
            style: ({ percent }) => ({
              fontSize: "16px",
              fill: "white"
            })
          },
          content: {
            style: ({ percent }) => ({
              fontSize: 60,
              lineHeight: 1,
              fill: "white"
            }),
            customHtml: (days01, view, { percent }) => {
              const { width, height } = days01.getBoundingClientRect();
              const d = Math.sqrt(
                Math.pow(width / 2, 2) + Math.pow(height / 2, 2)
              );
              const text = `${time}天`;
              const textWidth = measureTextWidth(text, { fontSize: 60 });
              const scale = Math.min(d / textWidth, 1);
              return `<div style="width:${d}px;display:flex;align-items:center;justify-content:center;font-size:${scale}em;line-height:${
                scale <= 1 ? 1 : "inherit"
              }">${text}</div>`;
            }
          }
        },
        liquidStyle: ({ percent }) => {
          return {
            fill: percent > 0.45 ? "#3b54d3" : "#2089ea",
            stroke: percent > 0.45 ? "#3b54d3" : "#2089ea"
          };
        },
        color: () => "#3b54d3"
      });
      liquidPlot.render();

      let data = 0.2;
      const interval = setInterval(() => {
        data += 0.1;
        if (data < 0.75) {
          liquidPlot.changeData(data);
        } else {
          clearInterval(interval);
        }
      }, 500);
    },
    // 设备工况看护数
    getDays02() {
      document.getElementById("days02").innerHTML = "";
      const liquidPlot = new Liquid(document.getElementById("days02"), {
        percent: 0.4,
        radius: 1,
        statistic: {
          title: {
            formatter: () => "看护",
            style: ({ percent }) => ({
              fontSize: "16px",
              fill: "white"
            })
          },
          content: {
            style: ({ percent }) => ({
              fontSize: 60,
              lineHeight: 1,
              fill: "white"
            }),
            customHtml: (days02, view, { percent }) => {
              const { width, height } = days02.getBoundingClientRect();
              const d = Math.sqrt(
                Math.pow(width / 2, 2) + Math.pow(height / 2, 2)
              );
              const text = `${this.memberAllList.length}户`;
              const textWidth = measureTextWidth(text, { fontSize: 60 });
              const scale = Math.min(d / textWidth, 1);
              return `<div style="width:${d}px;display:flex;align-items:center;justify-content:center;font-size:${scale}em;line-height:${
                scale <= 1 ? 1 : "inherit"
              }">${text}</div>`;
            }
          }
        },
        liquidStyle: ({ percent }) => {
          return {
            fill: percent > 0.45 ? "#3b54d3" : "#2089ea",
            stroke: percent > 0.45 ? "#3b54d3" : "#2089ea"
          };
        },
        color: () => "#3b54d3"
      });
      liquidPlot.render();

      let data = 0.25;
      const interval = setInterval(() => {
        data += 0.1;
        if (data < 0.5) {
          liquidPlot.changeData(data);
        } else {
          clearInterval(interval);
        }
      }, 500);
    },
    pausePlay() {
      this.audioPlayer.pause();
    },
    playAudio() {
      let second = 60;
      let that = this
      this.audioPlayer.play();
      // let playPromise;
      // playPromise = this.audioPlayer.play();
      // if (playPromise) {
      //   playPromise
      //     .then(() => {
      //       // 音频加载成功
      //       // 音频的播放需要耗时
      //       that.palyerTimer = setInterval(() => {
      //         second--;
      //         if (second <= 0) {
      //           that.audioPlayer.play();
      //           clearInterval(that.palyerTimer);
      //         }
      //       }, 1000);
      //     })
      //     .catch(e => {
      //       // 音频加载失败
      //       clearInterval(that.palyerTimer);
      //     });
      // }
    },
    //报警弹窗关闭
    alarmDialogCloseClick() {
      this.audioPlayer.pause();
    },
    //报警通知处理
    alarmHandleClick(value) {
      let cid = value;
      // let memberId = document.getElementById('memberId').innerHTML
      if(this.alarmHandleResult === '') {
        this.$message.error('请先输入处理结果!');
        return;
      }
      //设置老人报警处理结果
      let params = {
        remark: this.alarmHandleResult,
        handler: JSON.parse(sessionStorage.getItem("userInfo")).realName,
        isEffective: this.memberNoticeData.isEffective,
        cid: cid
      };
      datasApi
        .updateAlarmResult(params)
        .then(res => {
          if (res.code == "1") {
            this.$message({
              message: "提交成功!",
              type: "success"
            });
            this.sosLinkNameModal = false;
          }
          this.getAlarmData()
        })
        .catch(err => {
          this.getAlarmData()
        });
    },
    //实时报警弹窗处理结果
    remarkTextChange(value) {
      let cid = value;
      // let memberId = document.getElementById('memberId').innerHTML
      //设置老人报警处理结果
      if(this.remarkText.length == "") {
        this.$message({
          message: "请先输入处理结果!",
          type: "error"
        });
        return
      }
      let params = {
        remark: this.remarkText,
        handler: JSON.parse(sessionStorage.getItem("userInfo")).realName,
        isEffective: this.realtimeIsEffective,
        cid: cid
      };
      datasApi
        .updateAlarmResult(params)
        .then(res => {
          if (res.code == "1") {
            this.$message({
              message: "提交成功!",
              type: "success"
            });
            this.sosLinkNameModal = false;
            this.alarmDialogVisible = false;
            this.$nextTick(() => {
              this.getAlarmData()
            })
            // setTimeout(() => {
            //   this.getAlarmData()
            // },1000)
          }
        })
        .catch(err => {
          this.getAlarmData()
        });
    },
    //报警通知查看老人紧急联系人
    searchConnactClick(item) {
      this.sosLinkNameModal = true;
      this.memberNoticeData = item;
      this.alarmHandleResult = '';
      this.alarmHandleResultList = [];
      const resList = item.handleResult ? item.handleResult.split('&&') : [];
      for (let res of resList) {
        let item = res.split("-%");
        let obj = {};
        if (item.length === 1) {
          obj = {
            handler: '',
            handleTime: '',
            result: item[0]
          }
        }else {
          obj = {
            handler: item[0],
            handleTime: item[1],
            result: item[2]
          }
        }
        this.alarmHandleResultList.push(obj);
      }
    },
    sosLinkNameModalCloseClick() {
      this.sosLinkNameModal = false;
    },
    //呼救器
    getTalkSosUrl(item) {
      let params = {
        memberId: item.memberId
      };
      datasApi.getTalkSosUrl(params).then(res => {
        if (res.data && res.code == "1") {
          this.currentObj = item;
          this.callDrawer = true;
          this.talkSosUrl = res.data.talkUrl;
        } else {
          this.$message({
            message: "未查询到老人呼救",
            type: "error"
          });
        }
      });
    },
    callHelpClick(item) {
      this.getTalkSosUrl(item);
    },
    closeMydrawer() {
      this.callDrawer = false;
      this.currentObj = {};
      this.talkSosUrl = "";
    },
    //获取居住状况
    getOlderLiveStatus(type) {
      return getLiveStatusType(type);
    },
    //获取失能情况
    getOlderDisablity(type) {
      return getDisablityType(type);
    },
    //获取身份标签
    getOlderMemberTag(str) {
      if (str && str.length > 0) {
        return str.split(",");
      }
      return [];
    },
    getMemberTagType(type) {
      return getMemberTag(type);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;
  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    white-space: normal;
  }
}
.marker-using-slot {
  color: #fff;
  margin: 0;
  white-space: nowrap;
  padding: 0 10px;
  background-color: #3b54d3;
}
.dashboard-container {
  width: 100%;
  height: 100%;
  background-image: url("../assets/images/bg.jpg");
  background-size: cover;
}
.head-side {
  height: 104px;
  background-image: url("../assets/images/headsideBg.png");
  background-repeat: no-repeat;
}
.head-center {
  position: relative;
  height: 104px;
}
.head-center-left {
  position: absolute;
  left: 0;
  top: 0;
  width: 82px;
  height: 104px;
  background-image: url("../assets/images/headleftBg.png");
  background-repeat: no-repeat;
}
.head-center-right {
  position: absolute;
  right: 0;
  top: 0;
  width: 82px;
  height: 104px;
  background-image: url("../assets/images/headrightBg.png");
  background-repeat: no-repeat;
}
.head-supercenter {
  position: absolute;
  left: 82px;
  width: calc(100% - 164px);
  height: 104px;
  background-image: url("../assets/images/headcenterBg.png");
  text-align: center;
  background-repeat: repeat-x;
  h1 {
    font-size: 30px;
    color: #3b54d3;
    line-height: 88px;
    font-weight: 500;
  }
}
.row-content {
  padding: 15px;
  height: calc(100% - 50px);
  margin-top: -54px;
}
.row-content > .el-col {
  height: 100%;
}
.grid-content {
  width: 100%;
  height: 100%;
  background-color: rgba(111, 110, 119, 0.08);
  border-radius: 10px;
  border: 1px solid #232759;
  position: relative;
}
.grid-content:before,
.grid-content:after {
  position: absolute;
  width: 23px;
  height: 25px;
  content: "";
  top: -1px;
}
.grid-content:before {
  background: url("../assets/images/angleTopLeft.png") no-repeat 0 0;
  left: -1px;
}
.grid-content:after {
  background: url("../assets/images/angleTopRight.png") no-repeat 0 0;
  right: -1px;
}
.boxfoot {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.boxfoot:before,
.boxfoot:after {
  position: absolute;
  width: 23px;
  height: 25px;
  content: "";
  bottom: -1px;
}
.boxfoot:before {
  background: url("../assets/images/angleBottomLeft.png") no-repeat 0 0;
  left: -1px;
}
.boxfoot:after {
  background: url("../assets/images/angleBottomRight.png") no-repeat 0 0;
  right: -1px;
}
.moveup {
  height: 100%;
  top: -40px;
}
.move-up-first {
  top: -65px;
}
.move-up-second {
  top: -50px;
}
.supercenter {
  height: calc(100% - 40px);
}
.super-left {
  height: 100%;
}
.super-left-content {
  width: 100%;
  height: calc(45% - 0px);
}
.supercenter-content {
  width: 100%;
  height: calc(60% - 15px);
  padding-top: 15px;
}
.twoblock {
  display: flex;
  height: calc(40% - 15px);
  justify-content: space-between;
}
.half-item {
  width: 50%;
}
.left-half {
  padding-right: 7.5px;
}
.right-half {
  padding-left: 7.5px;
}
.inner {
  padding: 10px;
  height: calc(100% - 20px);
}
.inner-title {
  width: 100%;
  height: 50px;
  background-image: url("../assets/images/arrow.png");
  background-position: center bottom;
  background-repeat: no-repeat;
}
.inner-title h2 {
  line-height: 36px;
  font-size: 20px;
  color: #fff;
  font-weight: 500;
}
.inner-title h2 span {
  font-size: 14px;
}
.inner-content {
  padding-top: 10px;
  height: calc(100% - 60px);
}
.circle-box {
  display: flex;
  align-content: center;
}
.chart {
  height: 30%;
}
.alertList {
  padding-top: 10px;
  height: calc(70% - 10px);
}
.alertList {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.alert-item {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.alert-txt {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #fff;
}
.today-number {
  height: 20px;
  background-color: #2d324d;
  padding: 0 5px;
  border-radius: 8px;
  color: #a545ff;
  font-size: 12px;
  margin-left: 3px;
  display: inline-block;
  line-height: 20px;
}
.notinstall {
  color: #32b9ff;
}

.noticeList {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: -17px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.notice-item {
  color: #fff;
  background-color: #666 !important;
  margin-bottom: 10px;
  // display: flex;
  // align-items: center;
  // white-space: nowrap;
  padding: 10px;
  // justify-content: space-between;
}
.oldmanname {
  font-size: 15px;
  color: #fff;
  width: 70px;
}
.notice-block {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.tworow {
  display: flex;
  align-items: center;
  line-height: 30px;
  justify-content: space-between;
}
.tips {
  font-size: 12px;
  color: #3b7bd3;
}
.address {
  font-size: 12px;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -moz-box;
  -moz-line-clamp: 2;
  -moz-box-orient: vertical;
  overflow-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  overflow: hidden;
}
.address-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -moz-box;
  -moz-line-clamp: 2;
  -moz-box-orient: vertical;
  overflow-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  overflow: hidden;
}
.datetime {
  margin-left: 5px;
  flex: 1;
  font-size: 9px;
  color: #ccc;
  flex-shrink: 0;
}
.telphone {
  font-size: 11px;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
}
.havebg {
  background-color: rgba(3, 2, 17, 0.5);
  border-radius: 4px;
}
.manyflow {
  position: relative;
  overflow: hidden;
}
.chart-box-manyflow {
  overflow-y: auto;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
.chart-box-manyflow::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.el-tabs.bigTabs {
  height: 100%;
}
.bigTabs .el-tab-pane {
  height: 100%;
}
/deep/ .el-tabs__content {
  overflow-y: auto;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
/deep/ .el-tabs__content::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.people-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding-top: 30px;
  justify-content: flex-start;
}
.person-item {
  display: flex;
  flex-direction: column;
  width: calc(50% - 25px);
  background-color: #24232f;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  padding: 10px;
  margin-top: 15px;
  margin-right: 10px;
  cursor: pointer;
}
.person-item:nth-child(2n+1) {
  margin-right: 0px;
}

.person-top {
  display: flex;
  justify-content: space-between;
  flex: 1 1 100%;
}
.person-photo {
  width: 60px;
  height: 60px;
  margin-right: 5px;
  display: flex;
  align-items: center;
}
.person-photo img {
  width: 100%;
}
.other-info {
  display: flex;
  flex-direction: column;
  line-height: 24px;
  width: 185px;
  justify-content: start;
  flex: 1 1;
}
.other-info-top {
  display: flex;
  font-size: 14px;
}
.call-help-box {
  height: 60px;
  width: 60px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .item {
    width: 30px;
    height: 30px;
    border-radius: 15px;
    background-color: #67c23a;
    text-align: center;
    line-height: 35px;
  }
}
.primary-info {
  text-align: left;
  color: #839dc1;
}
.address-info {
  font-size: 12px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.attend {
  display: flex;
  flex-direction: column;
  background-color: #3a4269;
  width: 60px;
  height: 60px;
  justify-content: center;
  align-items: center;
  line-height: 24px;
  flex-shrink: 0;
}
.unnormal {
  background-color: #612dca;
}
.attend-txt {
  font-size: 12px;
  color: #cfcfcf;
}
.rightspace {
  margin-right: 10px;
}
.attend-state {
  font-size: 14px;
  color: #fff;
}
.person-down {
  margin-top: 15px;
  padding: 10px;
}
.icons-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.inline,
.outline {
  width: 28px;
  height: 28px;
  border-radius: 14px;
  font-size: 20px;
  border: none;
  padding: 0;
  margin-right: 10px !important;
  margin-left: 0px !important;
  margin-bottom: 10px !important;
}
.inline {
  background-color: #5e6bad;
  color: #fff;
}
.inline:hover {
  background-color: #5e6bad;
}
.outline {
  background-color: #404a5c;
  color: #cfcfcf;
}
.outline:hover {
  background-color: #404a5c;
}
.sex-info {
  margin-left: 10px;
}
.el-dialog .other-info-top .primary-info {
  font-size: 16px;
}
.el-dialog .primary-info.address-info {
  font-size: 14px;
}
.cell {
  width: 100%;
  margin-top: 10px;
  background-color: #2b3149;
  border-top: 2px solid #3b54d3;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
.cell-head {
  text-align: left !important;
  padding: 0 10px;
  line-height: 40px;
  font-size: 16px;
  color: #fff;
}
.cell-head span {
  font-size: 12px;
}
.cell-body {
  padding: 0 10px;
  margin-top: 10px;
}
.report {
  height: 625px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding-bottom: 10px;
}
.smallTabs {
  top: -50px;
  position: relative;
}
.small-cell {
  height: 200px;
}
.el-tab-pane {
  height: 100%;
}
.mini-cell {
  padding: 0 10px;
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.mini-left {
  width: 35%;
  padding-right: 40px;
}
.mini-right {
  width: 65%;
}
.mini-head {
  line-height: 14px;
  color: #fff;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.stand {
  border-left: 3px solid #878cac;
  padding: 0 20px 0 8px;
  white-space: nowrap;
}
.lie {
  height: 1px;
  background-color: #868cae;
  width: 99%;
}
.mini-left-list {
  margin-top: 10px;
}
.mini-left-item {
  display: flex;
  justify-content: space-between;
  line-height: 32px;
  align-items: center;
}
.mini-left-text {
  color: #cfcfcf;
  font-size: 12px;
  display: flex;
  align-items: center;
}
.mini-left-number {
  height: 24px;
  background-color: #2d324d;
  padding: 0 7px;
  border-radius: 12px;
  color: #a545ff;
  font-size: 12px;
  display: inline-block;
  line-height: 24px;
}
.mini-table {
  font-size: 12px;
}
.mini-right-table {
  height: 170px;
}
.device-box {
  height: 175px;
}
.mini-left-text .iconfont {
  color: #32b9ff;
  margin-right: 5px;
}
.alert-box {
  height: 183px;
}
.right-first-cell {
  margin-top: 0;
}
.other-img {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.other-img-box {
  width: 100%;
  height: 100%;
  background-image: url("../assets/images/other.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.service-img {
  width: 100%;
  height: 100%;
}
.device-service-img {
  width: 100%;
  height: 100%;
  background-image: url("../assets/images/device.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.service-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: calc(100% - 60px);
}
.service-txt {
  width: 70%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.service-item {
  display: flex;
  height: 25%;
  align-items: center;
}
.service-title {
  color: #fff;
  line-height: 26px;
  font-size: 14px;
  margin-right: 10px;
}
.service-data {
  display: flex;
  line-height: 26px;
}
.service-data span {
  margin-right: 10px;
}
.service-img {
  width: 45%;
}
.on {
  color: #a545ff;
  font-size: 12px;
}
.out {
  color: #32b9ff;
  font-size: 12px;
}
.service-days {
  display: flex;
  width: 100%;
  height: 40%;
  padding: 5% 0;
}
.day {
  width: 45%;
  margin-right: 5%;
}
.login-btn {
  position: absolute;
  right: -20px;
  top: 30px;
  cursor: pointer;
  z-index: 9999;
}
.login-btn img {
  width: 30px;
  height: 30px;
}
.el-dropdown-menu__item {
  color: #cfcfcf;
}

.person-center {
  padding: 10px;
  color: tomato;
}

.person-end {
  margin-top: 10px;
}
.person-contact {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  .contact-item {
    margin-right: 10px;
    color: white;
  }
}

@media (max-width: 1366px) {
  .service-txt {
    width: 65%;
  }
  .service-img {
    width: 35%;
  }
  .service-item {
    height: 20%;
  }
  .service-days {
    height: 60%;
  }
  .report {
    height: 298px;
    margin-top: 5px;
  }
  .cell {
    margin-top: 10px;
  }
  .cell-head {
    line-height: 30px;
  }
  .cell-body {
    margin-top: 5px;
  }
  .el-dialog .primary-info.address-info {
    font-size: 12px;
  }
  .device-box {
    height: 100px;
  }
  .alert-box {
    height: 124px;
  }
  .smallTabs {
    top: -40px;
  }
  .mini-right-table {
    height: 105px;
  }
  .small-cell {
    height: 150px;
  }
  .mini-left-item {
    line-height: 26px;
  }
  .mini-left-list {
    margin-top: 0;
  }
  .right-first-cell {
    margin-top: 8px;
  }
}
.activeMon {
  border-bottom: solid #612dca 1px;
}
.search-box {
  padding: 10px 0px;
  width: 80%;
}
/deep/ .el-input__inner {
  background-color: #2b3149;
  color: #fff;
  border: #2b3149 1px solid;
  border-radius: 20px;
}

.mydrawer {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 99998;
  background-color: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
}
.mydrawer-inner {
  width: 500px;
  height: 100%;
  background-color: #0c0c2e;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 99999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  color: #eee;
  animation: moveit 500ms;
}
@keyframes moveit {
  from {
    right: -1000px;
  }
  to {
    right: 0px;
  }
}

.mydrawer-head {
  height: 50px;
  border-bottom: 1px solid #161759 !important;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    font-size: 16px;
    color: #fff;
    font-weight: 500;
  }
  div {
    font-size: 32px;
    color: #fff;
    cursor: pointer;
  }
}
.mydrawer-body {
  height: calc(100% - 51px);
}
.mydrawer-connent {
  height: 100%;
  padding: 16px;
}
.real-call {
  height: calc(100% - 200px);
}
.box-flex {
  display: flex;
  flex-wrap: wrap;
}
.circleBox {
  position: relative;
  text-align: center;
  width: 33%;
  margin-bottom: 10px;
}
.circleCenter {
  position: absolute;
  top: 24px;
  left: 0px;
  width: 100%;
}

.el-progress-circle__track {
  stroke: #b7e5c1;
}

#alarmChart {
  width: 100%;
  height: 250px;
}

#pieChart {
  width: 100%;
  height: 250px;
  margin-top: calc(50% - 140px);
}

#deviceChart {
  width: 100%;
  height: 100%;
}

.chart-box {
  height: calc(55% + 10px);
}
.notice-content-top {
  color: #fff;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}
.result {
  font-size: 13px;
  color: #2be872;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
}
.member-detail-info {
  color: #fff;
  text-align: left;
  margin-top: 10px;
}
.detail-info-item {
  padding: 5px;
}
.detail-label-title {
  font-size: 13px;
  color: #839dc1;
}
.grid-left {
  width: 100%;
}
#memberAlterChart {
  width: 100%;
  height: 250px;
}
.pie-inner-content {
  margin-top: 20px;
}
.handle-result {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow:hidden;
  -webkit-box-orient: vertical;
  word-break: break-all;
  color: #2be872;
}

/deep/ .el-radio__label {
  color: white;
}
</style>
